import { render, staticRenderFns } from "./DataTableWithTitle.vue?vue&type=template&id=4c419e43"
import script from "./DataTableWithTitle.vue?vue&type=script&lang=js"
export * from "./DataTableWithTitle.vue?vue&type=script&lang=js"
import style0 from "./DataTableWithTitle.vue?vue&type=style&index=0&id=4c419e43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports